"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeCompressed = void 0;
class Compressed {
    constructor(element) {
        var _a, _b;
        this.element = null;
        this.parentElement = null;
        this.siblingElements = [];
        this.compressedAmount = null;
        this.className = null;
        this.toggle = false;
        this.element = element;
        this.parentElement = element.parentElement;
        this.compressedAmount = this.element.hasAttribute('data-js-compressed')
            ? parseInt(this.element.getAttribute('data-js-compressed') || '0', 10)
            : 0;
        this.siblingElements = [...(((_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.children) || [])]
            .filter(child => child !== this.element)
            .slice(this.compressedAmount);
        this.className = (_b = this.element) === null || _b === void 0 ? void 0 : _b.getAttribute('data-js-compressed-class');
        this.toggle = this.element.hasAttribute('data-js-compressed-toggle');
        if (!this.className) {
            this.siblingElements.forEach(sibling => {
                sibling.style.display = 'none';
            });
        }
        this.init();
    }
    init() {
        if (!this.element || !this.parentElement || this.siblingElements.length <= 0)
            return;
        this.element.setAttribute('is-compressed', '');
        this.element.style.cursor = 'pointer';
        this.clickListener();
    }
    clickListener() {
        var _a;
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.addEventListener('click', (e) => {
            var _a;
            e.preventDefault();
            e.stopPropagation();
            this.handleClick();
            if (!this.toggle)
                (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
        });
    }
    handleClick() {
        var _a, _b;
        if ((_a = this.element) === null || _a === void 0 ? void 0 : _a.hasAttribute('is-compressed')) {
            this.element.removeAttribute('is-compressed');
            console.log("has element attribute");
            this.toggleSiblingElements(false);
        }
        else {
            (_b = this.element) === null || _b === void 0 ? void 0 : _b.setAttribute('is-compressed', '');
            this.toggleSiblingElements(true);
        }
    }
    toggleSiblingElements(isCompressed) {
        var _a;
        (_a = this.siblingElements) === null || _a === void 0 ? void 0 : _a.forEach(sibling => {
            if (this.className) {
                isCompressed ? sibling.classList.add(this.className) : sibling.classList.remove(this.className);
            }
            else {
                sibling.style.display = isCompressed ? 'none' : '';
            }
        });
    }
}
function initializeElements(elements) {
    elements.forEach(element => {
        // Only initialize if the element has not been initialized before.
        if (element.hasAttribute('compressed-was-initialized')) {
            return;
        }
        element.setAttribute('compressed-was-initialized', '');
        new Compressed(element);
    });
}
function initializeCompressed() {
    initializeElements([...document.querySelectorAll('[data-js-compressed]')]);
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (!(node instanceof HTMLElement)) {
                    return;
                }
                if (node.hasAttribute('data-js-compressed')) {
                    initializeElements([node]);
                }
                else {
                    initializeElements([...node.querySelectorAll('[data-js-compressed]')]);
                }
            });
        });
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
exports.initializeCompressed = initializeCompressed;
exports.default = Compressed;
